import type { ConversationSummary } from '../api/conversation-summaries.api';

/**
 * Which message each summary's marker follows: the last one of the turn the summary ends on, which
 * is the one before the next turn's question. Placed by turn rather than by exchange id, because a
 * message that has not been reloaded since it streamed carries no exchange id.
 */
export function markersByMessage(
  messages: readonly { type: string }[],
  summaries: readonly ConversationSummary[],
): Map<number, ConversationSummary[]> {
  const questions = messages.flatMap((message, index) => (message.type === 'user' ? [index] : []));
  const placed = new Map<number, ConversationSummary[]>();
  for (const summary of [...summaries].reverse()) {
    const nextQuestion = questions.at(summary.coveredTurns);
    const after = (nextQuestion ?? messages.length) - 1;
    if (after < 0) continue;
    placed.set(after, [...(placed.get(after) ?? []), summary]);
  }
  return placed;
}
